/* ==========================================================================
   C13 HEALTH - Shop policy enhancer

   Shopify renders /policies/* with its own `shopify-policy__*` markup and
   ignores custom templates, so the premium chrome (hero, sticky index,
   closing card) is added here instead. Progressive: without JS the page
   still reads correctly, just without the surrounding furniture.
   ========================================================================== */
(function () {
  'use strict';

  var container = document.querySelector('.shopify-policy__container');
  if (!container) return;

  var titleEl = container.querySelector('.shopify-policy__title');
  var bodyEl  = container.querySelector('.shopify-policy__body');
  if (!bodyEl) return;

  var title = titleEl ? (titleEl.textContent || '').trim() : document.title.split('–')[0].trim();
  var path  = window.location.pathname.toLowerCase();

  var LEDE = {
    privacy: 'How we collect, use and protect your personal information when you visit or buy from this store.',
    refund: 'When and how you can return an order, and how refunds are handled.',
    shipping: 'Where we ship, how long it takes and what it costs.',
    terms: 'The terms you agree to when you use this website or place an order.',
    subscription: 'How recurring orders work, and how to change or cancel them.',
    contact: 'How to reach us, and who is responsible for this store.'
  };
  var lede = '';
  Object.keys(LEDE).forEach(function (k) { if (!lede && path.indexOf(k) > -1) lede = LEDE[k]; });

  var POLICY_LINKS = [
    { label: 'Privacy Policy', href: '/policies/privacy-policy' },
    { label: 'Shipping & Delivery', href: '/pages/shipping-and-delivery' },
    { label: 'Returns & Refunds', href: '/pages/returns' },
    { label: 'Accessibility', href: '/pages/accessibility' }
  ];

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---------- reading time ---------- */
  var words = (bodyEl.textContent || '').trim().split(/\s+/).length;
  var mins = Math.max(1, Math.round(words / 220));

  /* ---------- hero ---------- */
  var hero = document.createElement('section');
  hero.className = 'c13-pol__hero';
  hero.innerHTML =
    '<div class="c13-wrap"><div class="c13-pol__heroinner">' +
      '<nav aria-label="Breadcrumb"><ol class="c13-crumbs">' +
        '<li><a href="/">Home</a></li>' +
        '<li aria-current="page">' + esc(title) + '</li>' +
      '</ol></nav>' +
      '<p class="c13-eyebrow">Policies</p>' +
      '<h1 class="c13-pol__title">' + esc(title) + '</h1>' +
      (lede ? '<p class="c13-pol__lede">' + esc(lede) + '</p>' : '') +
      '<div class="c13-pol__meta">' +
        '<span>' + mins + ' min read</span>' +
        '<button type="button" class="c13-pol__print">Print or save as PDF</button>' +
      '</div>' +
    '</div></div>';
  container.parentNode.insertBefore(hero, container);
  hero.querySelector('.c13-pol__print').addEventListener('click', function () { window.print(); });

  /* ---------- two-column shell ---------- */
  var shell = document.createElement('div');
  shell.className = 'c13-polshell';

  var aside = document.createElement('aside');
  aside.className = 'c13-pol__aside c13-hide-md';
  aside.innerHTML =
    '<div>' +
      '<p class="c13-pol__navtitle">All policies</p>' +
      '<nav class="c13-pol__nav" aria-label="Policies">' +
        POLICY_LINKS.map(function (l) {
          var cur = window.location.pathname === l.href;
          return '<a href="' + l.href + '"' + (cur ? ' class="is-current" aria-current="page"' : '') + '>' + esc(l.label) + '</a>';
        }).join('') +
      '</nav>' +
    '</div>' +
    '<div data-toc-wrap>' +
      '<p class="c13-pol__navtitle">On this page</p>' +
      '<nav class="c13-pol__toc" data-c13-poltoc aria-label="Sections on this page"></nav>' +
    '</div>' +
    '<div class="c13-pol__help">' +
      '<p>Not sure how this applies to your order? We are happy to explain it in plain English.</p>' +
      '<a class="c13-link" href="/pages/contact">Contact us</a>' +
    '</div>';

  var main = document.createElement('div');
  bodyEl.parentNode.insertBefore(shell, bodyEl);
  shell.appendChild(aside);
  shell.appendChild(main);
  main.appendChild(bodyEl);
  bodyEl.classList.add('c13-pol__body');

  /* ---------- closing card ---------- */
  var foot = document.createElement('div');
  foot.className = 'c13-pol__foot';
  foot.innerHTML =
    '<div><h2>Still have a question?</h2><p>Write to us and a person will reply within one working day.</p></div>' +
    '<a class="c13-btn" href="/pages/contact">Contact us</a>';
  main.appendChild(foot);

  /* ---------- table of contents ---------- */
  var toc = aside.querySelector('[data-c13-poltoc]');
  var heads = bodyEl.querySelectorAll('h2');
  if (!heads.length) {
    aside.querySelector('[data-toc-wrap]').hidden = true;
  } else {
    var html = '';
    Array.prototype.forEach.call(heads, function (h, i) {
      if (!h.id) {
        h.id = 'section-' + (i + 1) + '-' +
          (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
      }
      html += '<a href="#' + h.id + '">' + esc(h.textContent) + '</a>';
    });
    toc.innerHTML = html;

    if ('IntersectionObserver' in window) {
      var links = toc.querySelectorAll('a');
      var map = {};
      Array.prototype.forEach.call(links, function (a) { map[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          Array.prototype.forEach.call(links, function (a) { a.classList.remove('is-current'); });
          if (map[e.target.id]) map[e.target.id].classList.add('is-current');
        });
      }, { rootMargin: '-12% 0px -74% 0px' });
      Array.prototype.forEach.call(heads, function (h) { io.observe(h); });
    }
  }
})();
